import { useMemo } from 'react';

import { useChallengeRewardsQuery } from '../GraphQL/ChallengeRewards.generated';

export const useChallengeRewards = () => {
  const [challengeRewardsResponse, fetchChallengeRewards] =
    useChallengeRewardsQuery({
      requestPolicy: 'network-only',
      pause: true,
    });

  const challengeRewards = challengeRewardsResponse.data?.challengeRewards;
  const isFetchingChallengeRewards = challengeRewardsResponse.fetching;
  const challengeRewardsError = challengeRewardsResponse.error;

  return useMemo(
    () => ({
      challengeRewards,
      isFetchingChallengeRewards,
      challengeRewardsError,
      fetchChallengeRewards,
    }),
    [
      challengeRewards,
      challengeRewardsError,
      fetchChallengeRewards,
      isFetchingChallengeRewards,
    ],
  );
};
